export default __webpack_public_path__ + "static/media/const7.74d06a49.jpg";